import { Signin } from 'views/signin';
import { Dashboard } from 'views/dashboard';
import { Accounts } from 'views/accounts';
import { Users } from 'views/users';
import { UserDetail } from 'views/userDetail';
import { Feedback } from 'views/feedback';
import { Support } from 'views/support';
import { Logs } from 'views/log/list';
import { LogDetail } from 'views/log/detail';
import { EventGroups } from 'views/event/groups';
import { Events } from 'views/event/list';
import { EventDetail } from 'views/event/detail';

const Routes = [
  {
    path: '/',
    view: Signin,
    layout: 'auth',
    title: 'Mission Control'
  },
  {
    path: '/signin',
    view: Signin,
    layout: 'auth',
    title: 'Mission Control'
  },
  {
    path: '/dashboard',
    view: Dashboard,
    layout: 'app',
    accountType: 'master',
    title: 'Mission Control'
  },
  {
    path: '/accounts',
    view: Accounts,
    layout: 'app',
    accountType: 'master',
    title: 'Accounts'
  },
  {
    path: '/users',
    view: Users,
    layout: 'app',
    accountType: 'master',
    title: 'Users'
  },
  {
    path: '/feedback',
    view: Feedback,
    layout: 'app',
    accountType: 'master',
    title: 'User Feedback'
  },
  {
    path: '/support',
    view: Support,
    layout: 'app',
    accountType: 'master',
    title: 'User Support'
  },
  {
    path: '/logs',
    view: Logs,
    layout: 'app',
    accountType: 'master',
    title: 'App Logs'
  },
  {
    path: '/logs/:id',
    view: LogDetail,
    layout: 'app',
    accountType: 'master',
    title: 'Log Detail'
  },
  {
    path: '/events',
    view: EventGroups,
    layout: 'app',
    accountType: 'master',
    title: 'Events'
  },
  {
    path: '/events/:group',
    view: Events,
    layout: 'app',
    accountType: 'master',
    title: 'Event'
  },
  {
    path: '/events/:group/:id',
    view: EventDetail,
    layout: 'app',
    accountType: 'master',
    title: 'Event Detail'
  },
  {
    path: '/users/:id',
    view: UserDetail,
    layout: 'app',
    accountType: 'master',
    title: 'User'
  },
]

export default Routes;